import { useQueryClient } from "@tanstack/react-query";
import { Badge, Button, Drawer, Popover } from "antd";
import useLoginModal from "hooks/useLoginModal";
import ArrowDownThinIcon from "icons/ArrowDownThinIcon";
import CartFillIcon from "icons/CartFillIcon";
import CreditCardIcon from "icons/CreditCardIcon";
import PersonIcon from "icons/PersonIcon";
import StarIcon from "icons/StarIcon";
import { useState } from "react";
import { useGetCart } from "services/cart";
import useUserStore from "stores/user";
import CartDrawerContent from "./CartDrawerContent";
import PaymentNotificationModal from "./PaymentNotificationModal";
import UserMenu from "./UserMenu";
import SearchInput from "./SearchInput";
import { useGetUserMe } from "services/user";

const SearchBar = () => {
  const { user, resetUser } = useUserStore();
  const { userInfo } = useGetUserMe();

  const { cartItemList } = useGetCart(user);
  const { loginModal, showLogin } = useLoginModal();
  const [isOpenPaymentNotiModal, setIsOpenPaymentNotiModal] =
    useState<boolean>(false);

  const [openUserMenu, setUserMenuOpen] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [openCartDrawer, setOpenCartDrawer] = useState<boolean>(false);
  const handleUserMenuChange = (newOpen: boolean) => {
    setUserMenuOpen(newOpen);
  };

  const onOpenDrawer = () => {
    setOpenCartDrawer(true);
  };

  const onCloseDrawer = () => {
    setOpenCartDrawer(false);
  };

  const onLogoutCallback = () => {
    setUserMenuOpen(false);
    queryClient.invalidateQueries({
      queryKey: ["getProduct"],
    });

    queryClient.invalidateQueries({
      queryKey: ["getBannerList"],
    });
    // Manually reset cart data to empty state instead of invalidating
    queryClient.setQueryData(["getCart"], { cartItems: [] });
    resetUser();
  };

  const handleClickLogin = () => {
    showLogin();
  };

  const onClosePaymentModal = () => {
    setIsOpenPaymentNotiModal(false);
  };

  const handleOnClickUpdatePaymentButton = () => {
    if (user) {
      setIsOpenPaymentNotiModal(true);
    } else {
      showLogin();
    }
  };

  return (
    <div className="h-[85px] bg-white flex justify-between items-center px-4">
      <SearchInput />
      <div className="flex gap-4 items-center px-4">
        <div>
          <Button
            className="text-[#1EB0A7] bg-[#E7F7F6] rounded-full"
            type="text"
            color="#1EB0A7"
            icon={<CreditCardIcon />}
            size="large"
            onClick={handleOnClickUpdatePaymentButton}
          >
            <span className="text-black">แจ้งชำระเงิน</span>
          </Button>
        </div>
        <div>
          {user ? (
            <Popover
              content={<UserMenu callback={onLogoutCallback} />}
              trigger="click"
              open={openUserMenu}
              onOpenChange={handleUserMenuChange}
              placement="bottom"
              overlayInnerStyle={{ padding: 0 }}
              className="cursor-pointer"
            >
              <div className="h-[40px] w-[220px] flex gap-4 text-primary items-center bg-[#F7F1FD] rounded-full">
                <div className="flex flex-[3] gap-4 bg-[#D4B5F430] h-full items-center rounded-full justify-center">
                  <StarIcon />
                  <span className="text-black">{userInfo?.capsulePoints}</span>
                </div>
                <div className="flex flex-[4] gap-4 justify-center">
                  <PersonIcon />
                  <span className="text-black">
                    {userInfo?.fullName.slice(0, 7)}
                  </span>
                  <ArrowDownThinIcon />
                </div>
              </div>
            </Popover>
          ) : (
            <Button
              size="large"
              shape="round"
              type="default"
              className="text-[#8A44ED]"
              style={{ borderColor: "#8A44ED" }}
              onClick={handleClickLogin}
            >
              เข้าสู่ระบบ / ลงทะเบียน
            </Button>
          )}
        </div>
        <div className="cursor-pointer pt-[3px]" onClick={onOpenDrawer}>
          <Badge count={cartItemList?.length} color="#9F341F">
            <CartFillIcon />
          </Badge>
        </div>
      </div>
      <Drawer
        onClose={onCloseDrawer}
        open={openCartDrawer}
        rootClassName={"cart-drawer-content"}
      >
        <CartDrawerContent />
      </Drawer>
      {isOpenPaymentNotiModal && (
        <PaymentNotificationModal
          isOpen={isOpenPaymentNotiModal}
          onClose={onClosePaymentModal}
        />
      )}

      {loginModal}
    </div>
  );
};

export default SearchBar;
